import React, { useEffect } from 'react';
import Styles from './activities-styles.scss';
import { ButtonBack } from '@/presentation/components';
import { useRecoilState } from 'recoil';
import { lessonState } from '@/presentation/pages/lessons/components/atoms';
import { useNavigate, useParams } from 'react-router';
import useLessons from '@/presentation/hooks/use-lessons';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import PencilActivity from '../../icons/pencil-activity';
import useRouterQuery from '@/presentation/hooks/use-router-query';
import SuccessActivity from './successActivity/SuccessActivity';
import UnSuccessActivity from './unSuccessActivity/unSuccessActivity';
import { ACTIVITIES_LIST } from '@/presentation/constants/student-activities-list';
const Activities = ({ manageProgressService, loadLessons, loadKeywords }) => {
    var _a, _b, _c, _d, _e;
    const [state] = useRecoilState(lessonState);
    const { user } = useUserSesssion();
    const { idModule, idLesson } = useParams();
    const moduleDashboardPath = ((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.description) === 'Teacher' ? '/teacher-dashboard/modules' : '/student-dashboard/my-modules';
    const navigate = useNavigate();
    const { menuItemsState } = useLessons({ manageProgressService, Styles, loadLessons });
    const index = menuItemsState === null || menuItemsState === void 0 ? void 0 : menuItemsState.findIndex(item => (item === null || item === void 0 ? void 0 : item.status) === 'current');
    const currentItem = menuItemsState[index];
    const activity = (_c = (_b = state === null || state === void 0 ? void 0 : state.lesson) === null || _b === void 0 ? void 0 : _b.lessonsActivities) === null || _c === void 0 ? void 0 : _c.find(activity => (activity === null || activity === void 0 ? void 0 : activity.id) === (currentItem === null || currentItem === void 0 ? void 0 : currentItem.id));
    const isCompleted = Boolean(currentItem === null || currentItem === void 0 ? void 0 : currentItem.completed);
    const query = useRouterQuery();
    useEffect(() => {
        if (query.get('success')) {
            if (currentItem === null || currentItem === void 0 ? void 0 : currentItem.onFinish) {
                currentItem.onFinish();
            }
        }
    }, [query, currentItem]);
    const startActivity = () => {
        var _a;
        console.log('startActivity');
        const queryParams = `?idModule=${idModule}&idLesson=${idLesson}&nameActivity=${activity === null || activity === void 0 ? void 0 : activity.name}&idProgress=${(_a = activity === null || activity === void 0 ? void 0 : activity.progressActivities) === null || _a === void 0 ? void 0 : _a.id}`;
        const nameActivity = activity === null || activity === void 0 ? void 0 : activity.name;
        console.log('nameActivity', nameActivity);
        console.log('ACTIVITIES_LIST', ACTIVITIES_LIST);
        const localActivity = ACTIVITIES_LIST.find(activity => activity.name === nameActivity);
        if (!localActivity) {
            console.error('Activity not found', nameActivity);
            return;
        }
        navigate(localActivity.path + queryParams);
    };
    const backModule = () => {
        navigate(`/student-dashboard/my-modules/${idModule}`);
    };
    if (state.isLoading || !state.lesson || !activity)
        return null;
    return (React.createElement("div", { className: Styles.activitiesWrap, id: "text-container" },
        React.createElement("div", { className: Styles.title },
            React.createElement(ButtonBack, { text: "Module", btnBackgroundGradient: "transparent", onClick: () => {
                    navigate(`${moduleDashboardPath}/${idModule}`);
                } }),
            React.createElement("div", { className: Styles.texts },
                React.createElement("span", null,
                    "lesson ", (_d = state === null || state === void 0 ? void 0 : state.lesson) === null || _d === void 0 ? void 0 :
                    _d.id),
                React.createElement("h3", null, (_e = state === null || state === void 0 ? void 0 : state.lesson) === null || _e === void 0 ? void 0 : _e.name))),
        React.createElement("div", { className: Styles.content },
            React.createElement("div", { className: Styles.header },
                React.createElement("span", { className: Styles.icon },
                    React.createElement(PencilActivity, { width: 29, height: 30 })),
                React.createElement("div", { className: Styles.headerTexts },
                    React.createElement("span", null, "Activity"),
                    React.createElement("span", { style: { fontWeight: 'bold', fontSize: '24px' } }, activity === null || activity === void 0 ? void 0 : activity.frontendConf.title))),
            isCompleted ? (React.createElement("div", null,
                React.createElement(SuccessActivity, { menuItemsState: menuItemsState, onBackModule: backModule, onStartActivity: startActivity }))) : (React.createElement("div", null,
                React.createElement(UnSuccessActivity, { menuItemsState: menuItemsState, onStartActivity: startActivity, isCompleted: isCompleted }))))));
};
export default Activities;
